import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-425e2038"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "M", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "mailto:contact@virtueal.cn",
  target: "_blank"
}, "contact@virtueal.cn", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "T", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "tel:086-010-51078067" }, "086-010-51078067", -1))
const _hoisted_5 = {
  class: "text-color",
  href: "https://beian.miit.gov.cn",
  target: "_blank"
}
const _hoisted_6 = { class: "icp" }

import { computed } from "vue";
import { useStore } from "vuex";

export default /*#__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

const store = useStore();
const isMobile = computed(() => !!store.state.isMobile as boolean);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['foot', { mobileSize: _unref(isMobile) }])
  }, [
    _createElementVNode("div", null, [
      _createTextVNode(_toDisplayString(_ctx.$t("user_center.contact_us")) + " | ", 1),
      _hoisted_1,
      _hoisted_2,
      _hoisted_3,
      _hoisted_4
    ]),
    _createElementVNode("div", null, _toDisplayString(_ctx.$t("header.company_address")), 1),
    _createElementVNode("a", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("header.copyright")), 1)
    ])
  ], 2))
}
}

})